<template>
  <!-- 商家详情顶部 -->
  <div class="BusinessDetailsTop main">
    <div class="content" v-for="(itemA,indexA) in list" :key="indexA">
      <el-row>
        <el-col :xs="12" :sm="2" class="contentLeft hidden-xs-only">
          <img src="../../../../public/static/images/yiErYi-logo.png" alt="" />
          <!-- <img :src="itemA.logoUrl" alt="" /> -->
        </el-col>
        <el-col :xs="6" :sm="2" :offset="9" class="contentLeft hidden-sm-and-up">
          <img src="../../../../public/static/images/yiErYi-logo.png" alt="" />
          <!-- <img :src="itemA.logoUrl" alt="" /> -->
        </el-col>
        <el-col :xs="24" :sm="14" class="contentCenter">
          <div class="title">{{msg.title}}</div>
          <div class="msg">{{msg.pattern}}</div>
          <div class="tag">
            <div v-for="(item,index) in msg.tag" :key="index">{{item}}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="7" class="contentBottom">
          <div class="fn">
            <div>
              <img src="../../../../public/static/images/collect2.png" alt="" />

              <img src="../../../../public/static/images/Weichet.png" alt="" />

              <img src="../../../../public/static/images/computer.png" alt="" />
            </div>
          </div>
          <div class="button">
            <div>
              <div class="buttonLeft">
                <img src="../../../../public/static/images/play1.png" alt="" />
                路演视频
              </div>
              <div class="buttonRight">查看BP</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      list: Array,
      msg: Object
    },
    components: {},
    watch: {
      msg(val) {
        val.tag = val.tag.split(',')
      }


    },
    data() {
      return {};
    },
    created: function () { },
    methods: {},
  };
</script>

<style scoped>
  @media (max-width: 768px) {
    .BusinessDetailsTop .content {
      padding-left: 15px;
      padding-right: 15px;
    }

    .BusinessDetailsTop .contentCenter {
      margin-left: 0px;
    }

    .BusinessDetailsTop .tag div {
      margin-right: 10px;
    }

    .BusinessDetailsTop .fn>div {
      margin: 0 auto;
    }

    .BusinessDetailsTop .button {
      margin-top: 20px;
    }

    .BusinessDetailsTop .button>div {
      margin: 0 auto;
    }
  }

  .BusinessDetailsTop {
    background-color: #1d1d1f;
    border-radius: 25px;

    margin-top: 40px;

  }

  .content {
    padding: 30px 30px 36px;
  }

  .contentLeft {
    /* width: 125px; */
    /* height: 125px; */
    background-color: #ffffff;
    border-radius: 50%;
  }

  .contentLeft img {
    display: block;
    margin: 0 auto;

    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .contentCenter {
    margin-left: 37px;
  }

  .title {

    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
  }

  .msg {
    margin-top: 13px;

    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #a1a1a1;
  }

  .tag {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
  }

  .tag div {
    margin-top: 22px;

    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #a0a0a2;
    border-radius: 5px;
    border: solid 1px #98989b;
    padding: 5px 10px;
    margin-right: 15px;
  }

  .contentBottom {}

  .fn {
    margin-top: 7px;
    display: flex;
    justify-content: right;
    /* justify-content: right; */
  }

  .fn>div {
    margin-left: auto;
  }

  .fn img {
    /* display: block; */
    /* float: right; */
    margin-right: 27px;
  }

  .contentBottom .fn img:last-child {
    margin-right: 0px;

  }

  .button {
    margin-top: 60px;
    display: flex;
    justify-content: right;

    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #e6e6e9;
  }

  .button>div {
    display: flex;
    margin-left: auto;
  }

  .button>div>div {
    border-radius: 20px;
    border: solid 1px #cecece;
  }

  .buttonLeft {
    position: relative;
    padding: 9px 0;
    padding-left: 53px;
    padding-right: 24px;
    margin-right: 10px;
  }

  .buttonLeft img {
    position: absolute;
    top: 7px;
    left: 21px;
  }

  .buttonRight {
    padding: 9px 29px;
  }
</style>